var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"issues-bulk-update right-sidebar",class:{ 'right-sidebar-expanded': _vm.expanded, 'right-sidebar-collapsed': !_vm.expanded }},[_c('div',{staticClass:"gl-border-b gl-flex gl-justify-between gl-p-4"},[_vm._t("bulk-edit-actions")],2),_vm._v(" "),_vm._t("sidebar-items")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }